<template>
  <div>
    <h2 class="mb-3">{{ $t("report.plural") }}</h2>

    <content-loading v-if="isLoading" />

    <b-row v-else-if="pagination">
      <b-col md="11">
        <FileNoAndCategorySelect id="fileNoAndCategorySelect" @selected="preapre" />
        <b-card v-for="item in pagination.docs" no-body class="custom-accordion shadow-none border-light bg-light border mb-1" :key="item._id">
          <b-card-body class="p-2  ">
            <div class="d-flex">
              <div>
                <i v-if="isDownloading(item._id)" class="bx bx-hourglass bx-spin font-size-24 float-left align-middle mr-3"></i>
                <span v-else>
                  <i
                    v-if="hasPermission"
                    class="mdi mdi-download font-size-24 float-left text-primary hand mr-1"
                    v-b-tooltip.hover
                    :title="$t('file-manager.download')"
                    @click="prepareForFileNoAndCategory(item)"
                  ></i>
                  <i
                    v-if="hasPermission"
                    class="bx bx-save font-size-24 float-left text-primary hand mr-3 mt-1  "
                    v-b-tooltip.hover
                    :title="$t('file-manager.save-to-files')"
                    @click="prepareForFileNoAndCategory(item, true)"
                  ></i
                ></span>
              </div>
              <div>
                <h4 class="mb-0">
                  {{ item.name | translate }}
                </h4>

                {{ item.description | translate }}
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FileNoAndCategorySelect from "../file-manager/file-no-and-category-select";
export default {
  components: { FileNoAndCategorySelect },
  computed: {
    pagination() {
      return this.$store.getters[`reportTemplate/pagination`];
    },
    isLoading() {
      return this.$store.getters[`reportTemplate/isLoading`];
    },

    hasPermission() {
      if (
        this.currentAccountHasPermissions(["ORGANIZATION_DDO_PRODUCT_ADMIN", "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN", "ORGANIZATION_RISK_ADMIN", "ORGANIZATION_LEGAL_ADMIN"])
      ) {
        return true;
      }

      return false;
    },
  },

  data() {
    return {
      selectedReportId: undefined,
      saveInsteadofDownload: false,
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: { products: { value: "DDO", isObject: true } },
      },
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.paginate();
      },
    },
  },
  mounted() {
    this.request.query.language = { value: this.currentLanguage, isObject: true };
  },
  methods: {
    isDownloading(id) {
      return this.$store.getters[`organizationReportTemplate/isDownloading`](id);
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },
    prepareForFileNoAndCategory(id, saveInsteadofDownload = false) {
      this.selectedReportId = id;
      this.saveInsteadofDownload = saveInsteadofDownload;
      this.$bvModal.show("fileNoAndCategorySelect");
    },
    async prepare(event) {
      if (!this.selectedReportId) {
        return;
      }
      try {
        const { data: file } = await this.$store.dispatch(`organizationReportTemplate/prepare`, {
          id: this.selectedReportId,
          saveInsteadofDownload: this.saveInsteadofDownload,
          fileCategoryId: event?.category?._id,
          fileNo: event?.fileNo,
          admin: { _id: event?.admin?._id, accountId: event?.admin?.accountId },
          isPeriodical: event?.isPeriodical,
          period: event?.period,
        });
        if (!this.saveInsteadofDownload) {
          this.download(file);
        } else {
          if (event.isPeriodical) {
            this.$store.commit("fileManager/selectedTab", 1);
            this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/${file._id}/survey`);
          }
        }

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async paginate() {
      await this.$store.dispatch(`reportTemplate/paginate`, this.request);
    },
  },
};
</script>
